import { t } from 'i18next'
import {
    HomeIcon,
    UsersIcon,
    CogIcon,
    CodeBracketSquareIcon,
    UserCircleIcon,
    RocketLaunchIcon,
    Squares2X2Icon,
    FingerPrintIcon,
    CircleStackIcon,
    IdentificationIcon,
} from '@heroicons/react/24/outline'

import { Language } from '@authy/lib-common/entities'
import { NavigationItem } from '@authy/lib-admin/appState'
import { env } from '@authy/lib-client/env'

import { appState } from '@/appState'

export const createMainNavigation = ({ language }: { language: Language }): NavigationItem[] => {
    const result: NavigationItem[] = []

    if (appState.tenant) {
        result.push({
            header: env.VITE_PRODUCT_NAME,
        })

        result.push({
            item: {
                name: t('navigation.tenant.home', { lng: language }),
                to: '/$tenantShortId',
                params: { tenantShortId: appState.tenant.shortId },
                activeOptions: { exact: true },
                Icon: HomeIcon,
            },
        })

        if (appState.tenantAccess?.owner) {
            result.push({
                item: {
                    name: t('navigation.tenant.users', { lng: language }),
                    to: '/$tenantShortId/users',
                    params: { tenantShortId: appState.tenant.shortId },
                    Icon: UsersIcon,
                },
            })
        }

        result.push({
            header: t('navigation.tenant.authenticationHeader', { lng: language }),
        })

        if (appState.tenantAccess?.owner || appState.hasTenantPermissions({ identity: { read: true } })) {
            result.push({
                item: {
                    name: t('navigation.tenant.identities', { lng: language }),
                    to: '/$tenantShortId/identities',
                    params: { tenantShortId: appState.tenant.shortId },
                    Icon: IdentificationIcon,
                },
            })
        }

        if (appState.tenantAccess?.owner || appState.hasTenantPermissions({ tenant: { edit: true } })) {
            if (appState.hasTenantPermissions({ tenant: { edit: true } })) {
                result.push({
                    item: {
                        name: t('navigation.tenant.settings', { lng: language }),
                        to: '/$tenantShortId/settings',
                        params: { tenantShortId: appState.tenant.shortId },
                        Icon: CogIcon,
                    },
                })

                result.push({
                    item: {
                        name: t('navigation.tenant.authProviders', { lng: language }),
                        to: '/$tenantShortId/auth-providers',
                        params: { tenantShortId: appState.tenant.shortId },
                        Icon: FingerPrintIcon,
                    },
                })
            }
        }

        if (appState.tenantAccess?.owner || appState.hasTenantPermissions({ application: { read: true } })) {
            result.push({
                item: {
                    name: t('navigation.tenant.applications', { lng: language }),
                    to: '/$tenantShortId/applications',
                    params: { tenantShortId: appState.tenant.shortId },
                    Icon: Squares2X2Icon,
                },
            })
        }

        if (appState.tenantAccess?.owner || appState.hasTenantPermissions({ tenant: { edit: true } })) {
            result.push({
                item: {
                    name: t('navigation.tenant.apis', { lng: language }),
                    to: '/$tenantShortId/apis',
                    params: { tenantShortId: appState.tenant.shortId },
                    Icon: CircleStackIcon,
                },
            })
        }

        if (appState.showUpcomingFeatures && appState.tenantAccess?.owner) {
            result.push({
                header: t('navigation.tenant.otherHeader', { lng: language }),
            })

            result.push({
                item: {
                    name: t('navigation.tenant.developer', { lng: language }),
                    to: '/$tenantShortId/developer',
                    params: { tenantShortId: appState.tenant.shortId },
                    Icon: CodeBracketSquareIcon,
                },
            })
        }
    } else {
        result.push(
            {
                item: {
                    name: t('navigation.start', { lng: language }),
                    to: '/user/start',
                    Icon: RocketLaunchIcon,
                },
            },
            {
                item: {
                    name: t('navigation.myProfile', { lng: language }),
                    to: '/user/profile',
                    Icon: UserCircleIcon,
                },
            }
        )
    }

    return result
}
